import { BeachType } from '@/models/license'

let isPoolSetupDone = false

export function getIsPool(): boolean {
  const url = new URL(window.location.href)
  return url.host.includes('inpiscina.it')
}

export function getIsPoolBeachType(
  beachType: BeachType | null | undefined
): boolean {
  return beachType === BeachType.POOL || beachType === BeachType.WATER_PARK
}

export function setupPool() {
  if (isPoolSetupDone) {
    return
  }

  document.body.classList.add('pool')

  const title = document.head.querySelector('title')
  if (title) {
    title.innerText = 'inpiscina.it'
  }
  const appName = document.head.querySelector('meta[name="application-name"]')
  if (appName) {
    appName.setAttribute('content', 'inpiscina.it')
  }

  // remove all apple icons
  document.head
    .querySelectorAll('link[rel="apple-touch-icon-precomposed"]')
    .forEach((e) => {
      e.remove()
    })

  // remove all msapplication icons
  document.head.querySelectorAll('meta[name^="msapplication"]').forEach((e) => {
    e.remove()
  })

  // remove all favicon
  document.head.querySelectorAll('link[href^="/favicon"]').forEach((e) => {
    e.remove()
  })

  // change favicon
  const link = document.createElement('link')
  link.rel = 'icon'
  link.href = '/favicon/inpiscina/favicon.ico'
  document.head.appendChild(link)

  isPoolSetupDone = true
}
